<template>
  <div id="reviews" class="pt-40 lg:pt-40">
    <div class="blogPost -comments">
      <div class="blogPost__content">
        <h2 class="text-24 fw-600"> {{ $t('reviews') }}</h2>
        <p class="text-20 mt-3" v-if="reviews?.length === 0"> {{ $t('no_reviews') }} </p>
        <ul class="comments__list mt-30">
          <!----- User Comment------------->
          <li class="comments__item" v-for="userReview in reviews" :key="userReview?.id">
            <div class="comments__item-inner md:direction-column">
              <div class="mr-20">
                <div class="user-img-1 d-flex align-items-center justify-content-center bg-light-3 rounded-full-1 p-2"
                  v-if="!userReview?.student.avatar">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path
                      d="M1 15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11H13C14.0609 11 15.0783 11.4214 15.8284 12.1716C16.5786 12.9217 17 13.9391 17 15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15Z"
                      stroke="#062B3B" stroke-width="1.5" stroke-linejoin="round" />
                    <path
                      d="M9 7C10.6569 7 12 5.65685 12 4C12 2.34315 10.6569 1 9 1C7.34315 1 6 2.34315 6 4C6 5.65685 7.34315 7 9 7Z"
                      stroke="#062B3B" stroke-width="1.5" />
                  </svg>

                </div>

                <div class="user-img-1 d-flex align-items-center justify-content-center rounded-full-1 overflow-hidden"
                  v-else>
                  <img :src="userReview?.student.avatar" width="" height="" alt="user-image" class="img-fluid">
                </div>
              </div>

              <div class="comments__body md:mt-15">
                <div class="comments__header">
                  <h4 class="text-24 fw-600">
                    {{ userReview?.student.name }}
                    <!----<span class="text-13 text-light-1 fw-400">3 Days ago</span>-->
                  </h4>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <!----<h5 class="text-16 fw-400 mt-5">UI-UX Designer</h5>-->
                  <span class="text-16 text-light-1 fw-400 d-block">
                    <rating-component :rating="userReview?.rating"></rating-component>
                  </span>
                  <span class="text-16 text-light-1 fw-400">{{ userReview?.updated_at }} </span>
                </div>

                <div class="comments__text mt-10">
                  <p>
                    {{ userReview?.review }}
                  </p>
                </div>
              </div>
            </div>
          </li>

        </ul>
      </div>
    </div>

    <!---------Pagination start------------->
    <div v-if="reviews.length > 1">
      <PaginationComponent v-model:currentPage="currentPage" :lastPage="totalPages" :maxVisiblePages="1"
        @update:currentPage="handlePageChange" />

    </div>

    <div class="respondForm pt-60" v-if="courseItem?.enrollment['is_enrolled']">
      <h3 class="text-24 fw-600">{{ $t("leave_a_review") }}</h3>

      <div class="alert alert-danger mb-3 mt-4" v-if="serverError">
        {{ serverError }}
      </div>

      <form class="contact-form respondForm__form row y-gap-30 pt-30" @submit.prevent="addReview">
        <div class="col-12">
          <label aria-label="hidden" class="d-none"> Review Content </label>
          <textarea name="comment" :placeholder="$t('leave_a_review')" rows="8" v-model="review"
            max-length="500"></textarea>

          <span class="errorMessage text-danger d-block mt-2" v-if="v$.review.$error">
            {{ v$.review.$errors[0].$message }}
          </span>
        </div>
        <div>
          <star-rating v-model="rating" :increment="1" :star-size="35" :rtl="isRTL" :show-rating="true"
            @update:rating="setRating"></star-rating>

          <span class="errorMessage text-danger d-block mt-2" v-if="v$.rating.$error">
            {{ v$.rating.$errors[0].$message }}
          </span>
        </div>

        <div class="col-12 d-flex justify-content-end">
          <button type="submit" id="submit" class="button-main text-capitalize fw-600 text-16"
            :disabled="!isAuthenticated">
            {{ $t("post") }}
          </button>
        </div>
      </form>

    </div>
    <SuccessPopup :isSuccessPopupVisible="successPopupVisible" :isComment="true" @close-popup="handlePopupClose" />
  </div>
</template>
<script>
import SuccessPopup from "../common/SuccessPopup.vue";
import PaginationComponent from "../common/PaginationComponent.vue";
import RatingComponent from "../common/RatingComponent.vue";
import { addUpdateReview, courseReviews } from "@/Services/api/CoursesService";
import store from "@/store";
import useVuelidate from '@vuelidate/core'
import { required, maxLength } from '@vuelidate/validators'
import StarRating from 'vue-star-rating'
import { mapGetters } from 'vuex';

export default {
  components: {
    StarRating,
    RatingComponent,
    SuccessPopup,
    PaginationComponent
  },
  data() {
    return {
      rating: null,
      isPaid: store.state.isPaid,
      isRTL: true,
      review: '',
      validationError: false,
      serverError: "",
      successPopupVisible: false,
      reviews: [],
      paginationData: null,
      currentPage: 1,
      totalPages: 1,
      perPage: 8
    };
  },
  setup() {
    return { v$: useVuelidate() }
  },
  validations() {
    return {
      rating: { required },
      review: { required, maxLength: maxLength(500), }
    }
  },
  computed: {
    courseItem() {
      return this.$store.getters.courseItem;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    ...mapGetters(['currentLanguage']),
    courseId() {
      return this.$route.params.id;
    },
    combinedWatcher() {
      return {
        language: this.currentLanguage,
        id: this.courseId,
      };
    },
  },
  methods: {
    setRating(rating) {
      this.rating = rating;
    },

    //pagination page change
    handlePageChange(newPage) {
      this.getCourseReview(newPage);
    },

    //get Course Review
    async getCourseReview() {
      try {
        const response = await courseReviews(this.courseId, this.currentPage);
        this.reviews = response.data.data;
        let meta = response.data.meta;
        this.perPage = meta.per_page;
        this.currentPage = meta.current_page;
        this.totalPages = meta.last_page;
      } catch (error) {
        console.log(error)
      }
    },

    //close pop up
    handlePopupClose() {
      this.successPopupVisible = false
    },

    //add review
    async addReview() {
      try {
        this.v$.$validate();
        if (!this.v$.$error) {
          let reviewData = {
            rating: this.rating,
            review: this.review
          }
          await addUpdateReview(this.courseId, reviewData);
          this.successPopupVisible = true;
          this.resetForm();
          this.getCourseReview();
        }
      } catch (error) {
        this.serverError = error.message;
      }
    },

    //reset form
    resetForm() {
      this.rating = null
      this.review = '';
      this.serverError = '';
      this.v$.$reset();
    }
  },
  watch: {
    // Combined watcher for both currentLanguage and courseId
    combinedWatcher: {
      handler() {
        this.isRTL = this.currentLanguage === 'ar';
        this.getCourseReview(this.courseId);
      },
      immediate: true, // Run the handler immediately when the component is mounted
    },
  },
  mounted() {
  
  },
};
</script>
<style lang="scss" scoped>
h2,
h3,
h5 {
  color: var(--Primary-600, #09445d);

  &:lang(en) {
    font-family: "Montserrat", sans-serif;
  }

  &:lang(ar) {
    font-family: "Almarai", serif;
  }
}

.img-container {
  width: 70px;
  height: 70px;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  border-radius: 50%;
  overflow: hidden;

  img {
    -o-object-fit: cover;
    object-fit: cover;
  }
}

.comments__header {
  h4 {
    color: #333;
  }
}

h5 {
  color: #333;
}

.comments__text {
  p {
    color: #4d4d4d;
    font-family: "Montserrat", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 140%;
  }
}

textarea {
  border-radius: 16px;
  border: 1px solid var(--Neutral-200, #e6e6e6);
  background: var(--Neutral-50, #fff);
}

.button-main {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 12px 40px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: #062b3b;
  color: #fff;
  border: 1px solid #062b3b;

  &:hover {
    cursor: pointer;
    background: transparent;
    border: 1px solid #062b3b;
    color: #062b3b;
  }
}
</style>
